import { Box, TextField } from '@mui/material';
import PropTypes from 'prop-types';

import titleCase from 'common/utils/titleCase';

// Values are usually strings, but the scan app can send numbers (e.g. quantity).
const isEmpty = (v) => v === null || v === undefined || String(v).trim().length === 0;

// drugName/strength arrive straight from the scan app's websocket payload
// (no GraphQL layer sits in front of it to title-case at the source), so it's
// applied here at the shared value accessor instead of at every call site.
const CASED_KEYS = new Set(['drugName', 'strength']);
const displayValue = (key, value) => (CASED_KEYS.has(key) && value ? titleCase(value) : value);

const EditableFields = ({ fields, values, onChange, disabled }) => (
  <Box
    sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: 1 }}
  >
    {fields.map(({ key, label, required, alwaysEditable, warn, warnText }) => {
      const value = displayValue(key, values?.[key]) ?? '';
      const missingRequired = required && isEmpty(value);
      const showError = missingRequired || !!warn;
      let helperText;
      if (missingRequired) helperText = 'Required';
      else if (warn) helperText = warnText;
      return (
        <TextField
          key={key}
          size='small'
          variant='outlined'
          label={label}
          value={value}
          onChange={(e) => onChange({ [key]: e.target.value })}
          onBlur={(e) => {
            const trimmed = e.target.value.trim();
            if (trimmed !== e.target.value) onChange({ [key]: trimmed });
          }}
          disabled={disabled && !alwaysEditable}
          required={!!required}
          error={showError}
          helperText={helperText}
          InputLabelProps={{ shrink: true }}
        />
      );
    })}
  </Box>
);

EditableFields.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      required: PropTypes.bool,
      alwaysEditable: PropTypes.bool,
      warn: PropTypes.bool,
      warnText: PropTypes.string,
    })
  ).isRequired,
  values: PropTypes.shape({}),
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

EditableFields.defaultProps = {
  values: {},
  disabled: false,
};

export default EditableFields;
